<template>
    <div>
        <oss-dialog
            @keydown.esc="dialog = false"
            v-model="dialog"
            :title="accountableAccountEdition.name ? 'Éditer' : 'Créer'"
            width="800px"
        >
            <template v-slot:actions>
                <v-btn-primary
                    rounded
                    block
                    @click="onValidateClick"
                    :disabled="!validAccount"
                    size="x-large"
                    >Valider</v-btn-primary
                >
            </template>

            <v-card class="default_card large mx-0 pa-2" elevation="0" style="width: 600px">
                <!-- <v-row class="py-3">
                            <v-alert
                                :value="existingName"
                                text
                                color="warning"
                                icon="warning"
                            >{{'Le compte ' + existingDescription + ' existe déjà' }}</v-alert>
                        </v-row> -->
                <v-form v-model="validAccount">
                    <v-row no-gutters>
                        <v-col cols="4" style="overflow-y: auto">
                            <!-- <oss-text-field
                                    :hide-details="true"
                                    outlined dense
                                    v-model="accountableAccountEdition.name"
                                    label="Numéro de compte"
                                    type="number"
                                    class="px-1 py-1 oss-"
                                    :disabled="!!accountableAccountEdition.id"
                                    :rules="[v => (v!=='' && v.length===aaCharacterCount) || $t('settings.positiveNumber')]"
                                ></oss-text-field> -->
                            <v-text-field-filled
                                v-model="accountableAccountEdition.name"
                                class="px-1 py-1"
                                autofocus
                                label="Numéro de compte"
                                :hide-details="'auto'"
                                :data-cy="cypressPrefixKey + 'accountableAccountEdition-name'"
                                :rules="[rules.aaLength, rules.checkExists, rules.isAA]"
                                :disabled="accountableAccountEdition.disabled"
                                v-if="!accountableAccountEdition.id"
                            />
                            <v-text-field-filled
                                :model-value="accountableAccountEdition.name"
                                class="px-1 py-1"
                                autofocus
                                label="Numéro de compte"
                                disabled
                                :data-cy="cypressPrefixKey + 'accountableAccountEdition-name'"
                                v-else
                            />
                        </v-col>
                        <v-col cols="8" style="overflow-y: auto">
                            <v-text-field-filled
                                v-model="accountableAccountEdition.description"
                                label="Description"
                                hide-details
                                class="px-1 py-1"
                                :rules="[(v) => v !== '']"
                                :readonly="accountableAccountEdition.disabled"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex mt-3">
                        <v-col cols="12" class="d-flex justify-center align-center">
                            <v-input
                                v-model="accountableAccountEdition.thirdParty"
                                :rules="[rules.thirdParty]"
                                hide-details="auto"
                                class="centered-input"
                            >
                                <template #default>
                                    <v-chip-group
                                        v-model="accountableAccountEdition.thirdParty"
                                        @update:model-value="
                                            accountableAccountEdition.onThirdPartyChanged()
                                        "
                                        :disabled="thirdPartyReadOnly || is6Account(accountableAccountEdition.name)"
                                        :style="is6Account(accountableAccountEdition.name) ? 'opacity: 0.4' : ''"
                                    >
                                        <template
                                            v-for="option in thirdParties"
                                            :key="option.value"
                                        >
                                            <v-chip
                                                variant="text"
                                                color="white"
                                                :disabled="accountableAccountEdition.disabled"
                                                :value="option.value"
                                                size="small"
                                            >
                                                <v-icon
                                                    v-if="
                                                        accountableAccountEdition.thirdParty !==
                                                        option.value
                                                    "
                                                    color="secondary"
                                                    size="small"
                                                    icon="$oss-circle-uncheck"
                                                />
                                                <v-icon
                                                    v-else
                                                    color="secondary"
                                                    size="small"
                                                    icon="$oss-circle-check"
                                                />
                                                <span
                                                    style="
                                                        color: rgba(0, 0, 0, 0.87);
                                                        font-size: 14px;
                                                    "
                                                    class="pl-2"
                                                    >{{ option.text }}</span
                                                >
                                            </v-chip>
                                        </template>
                                    </v-chip-group>
                                </template>
                            </v-input>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex pt-3">
                        <v-col cols="12" class="d-flex justify-center align-center">
                            <v-checkbox
                                density="compact"
                                v-model="accountableAccountEdition.lettering"
                                label="À lettrer"
                                hide-details
                                :disabled="is6Account(accountableAccountEdition.name)"
                                @change="letteringHasChangedCount += 1"
                                class="pr-2"
                            />
                            <v-checkbox
                                v-if="!is6or7Account(accountableAccountEdition.name)"
                                :disabled="accountableAccountEdition.lettering || is6Account(accountableAccountEdition.name)"
                                density="compact"
                                v-model="accountableAccountEdition.detailedCarryForward"
                                label="À-nouveaux détaillés"
                                hide-details
                                class="pl-2"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex pt-3" v-if="enableAccountPublish">
                        <v-col
                            cols="4"
                            class="d-flex justify-center align-center"
                            style="overflow-y: auto"
                        >
                            <v-checkbox
                                density="compact"
                                v-model="accountableAccountEdition.publish"
                                label="Publier au client"
                                hide-details
                                class="pr-2"
                            />
                        </v-col>
                        <v-col cols="8" style="overflow-y: auto">
                            <v-text-field-filled
                                v-model="accountableAccountEdition.shortDescription"
                                label="Description proposée au client"
                                hide-details
                                class="px-1 py-1"
                                :rules="accountableAccountEdition.publish ? [(v) => v !== ''] : []"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex pt-6" v-if="isVatOrSalesAccount">
                        <v-col cols="12" class="d-flex justify-center align-center">
                            <v-icon
                                @click.stop="
                                    accountableAccountEdition.vatRate = null;
                                    accountableAccountEdition.vatType = null;
                                    accountableAccountEdition.vatOperationType = null;
                                "
                                class="mr-3"
                                size="small"
                                icon="$oss-close"
                            />
                            <v-select-filled
                                :cols="isVatAccount ? 4 : 6"
                                v-model="accountableAccountEdition.vatRate"
                                :items="vatRates"
                                item-title="text"
                                item-value="value"
                                required
                                density="compact"
                                label="Taux de TVA"
                                hide-details="auto"
                                class="px-1 py-1"
                                :disabled="!!accountableAccountEdition.vatType"
                            />
                            <v-select-filled
                                :cols="isVatAccount ? 4 : 6"
                                v-model="accountableAccountEdition.vatType"
                                :items="vatTypes"
                                item-title="text"
                                item-value="value"
                                required
                                density="compact"
                                label="Type de TVA"
                                hide-details="auto"
                                class="px-1 py-1"
                                v-if="accountableAccountEdition.vatRate === 0"
                            />
                            <v-select-filled
                                v-if="isVatAccount"
                                cols="4"
                                v-model="accountableAccountEdition.vatOperationType"
                                :items="vatOperationTypes"
                                item-title="text"
                                item-value="value"
                                required
                                density="compact"
                                label="Type d'opération"
                                hide-details="auto"
                                class="px-1 py-1"
                            />
                        </v-col>
                    </v-row>
                    <template v-if="isZtillReceipt">
                        <v-row no-gutters class="d-flex py-3">
                            <v-divider />
                            <span class="text-subtitle-1 font-weight-regular pt-2 px-3"
                                >Affectation automatique</span
                            >
                        </v-row>
                        <v-row no-gutters class="d-flex" v-if="isZtillReceipt">
                            <v-col
                                :cols="isFiveAccount ? 6 : 9"
                                class="d-flex justify-center align-center"
                            >
                                <v-select-filled
                                    v-model="accountableAccountEdition.transactionType"
                                    :items="transactionTypes"
                                    item-title="text"
                                    item-value="value"
                                    density="compact"
                                    label="Transaction bancaire"
                                    hide-details="auto"
                                    class="px-1 py-1"
                                    :disabled="
                                        isDefaulted || !!accountableAccountEdition.paidAndUncashed
                                    "
                                />
                            </v-col>
                            <v-col
                                cols="3"
                                v-if="isFiveAccount"
                                class="d-flex justify-center align-center"
                            >
                                <v-checkbox-btn
                                    v-model="accountableAccountEdition.paidAndUncashed"
                                    label="Payé et non encaissé"
                                    color="primary"
                                    :disabled="
                                        isDefaulted || !!accountableAccountEdition.transactionType
                                    "
                                    :ripple="false"
                                />
                            </v-col>
                            <v-col cols="3" class="d-flex justify-center align-center">
                                <v-switch
                                    hide-details="auto"
                                    v-model="accountableAccountEdition.default"
                                    label="Par défaut"
                                    class="d-flex px-1"
                                    :disabled="
                                        isDefaulted ||
                                        !(
                                            accountableAccountEdition.transactionType ||
                                            accountableAccountEdition.paidAndUncashed
                                        )
                                    "
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-form>
            </v-card>
        </oss-dialog>
        <oss-dialog
            @close="cancelDeleteLetteringsChoice"
            v-model="confirmationDialog"
            title="Confirmation"
            v-if="confirmationDialog"
            width="800px"
        >
            <template v-slot:actions>
                <v-btn-primary rounded block @click="confirmDeleteLetteringsChoice" size="x-large"
                    >Confirmer</v-btn-primary
                >
            </template>

            <v-row no-gutters>
                <v-col cols="12" style="overflow-y: auto">
                    <div dense outlined class="px-1 py-1 oss-">
                        Si vous décochez la case "À-lettrer", les lettrages des exercices non clos
                        seront supprimés de manière irréversible.
                    </div>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            @close="cancelPropagation"
            v-model="propagationDialog"
            title="Souhaitez-vous propager les modifications ?"
            validTitle="Confirmer"
            @valid="confirmPropagation"
            v-if="propagationDialog"
            width="800px"
        >
            <v-row dense hide-details class="mx-2">
                <v-col class="d-flex justify-center align-center">
                    <template v-for="item in propagation" :key="item.title">
                        <v-list-item :title="item.title" v-if="item.show">
                            <template v-slot:prepend>
                                <v-list-item-action start>
                                    <v-checkbox-btn
                                        color="primary"
                                        v-model="item.active"
                                    ></v-checkbox-btn>
                                </v-list-item-action>
                            </template>
                            <!-- <template v-slot:append>
                                <v-chip color="light_grey" variant="flat" density="compact">{{ item.old }}</v-chip>
                                <v-icon icon="$keyboard_arrow_right" size="medium"/>
                                <v-chip color="light_grey" variant="flat" density="compact">{{ item.new }}</v-chip>
                            </template> -->
                        </v-list-item>
                    </template>
                </v-col>
            </v-row>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import { getAccountableAccountType } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";
import gql from "graphql-tag";
import { checkInt } from "../../services/mathServices";
import { AANode } from "./AccountableAccountNode";
import {
    vatRatesAccountableAccount,
    vatTypesForSalesAA,
    vatTypesForVatAA,
} from "@/services/vatServices";
import { Component, Vue, toNative, Prop, Watch, Model } from "vue-facing-decorator";

@Component({
    emits: ["validate"],
})
export class AccountableAccountEdition extends Vue {
    // @Prop({ default: false }) value!: boolean;
    // @Prop() readonly value!: boolean;
    @Prop({ default: 6 }) aaCharacterCount: number;
    @Prop({ default: null }) accountableAccount: AANode;
    @Prop({ default: null }) existingAccountableAccounts: any[];
    @Prop({ default: false }) authorizeExistingAAModification: boolean;
    @Prop({ default: false }) fromParentTable: boolean;

    @Model() value;

    cypressPrefixKey = "accountableAccount-edition";

    validAccount: boolean = false;
    accountableAccountEdition = new AANode(
        "",
        "",
        "",
        "",
        false,
        false,
        false,
        null,
        null,
        null,
        "",
        false,
        false,
        false,
        null,
        null,
        null,
        false,
    );
    previousAccountableAccountEdition = null;
    confirmationDialog: boolean = false;
    wantToDeleteLetterings: boolean = false;
    letteringHasChangedCount: number = 0;
    thirdParties = [
        { text: "Utilisateur", value: "user" },
        { text: "Compte Bancaire", value: "bankAccount" },
        { text: "Société Tiers", value: "thirdPartyCompany" },
    ];

    propagationDialog: boolean = false;
    propagation = [
        {
            title: "Description",
            value: "description",
            old: undefined,
            new: undefined,
            active: false,
            show: false,
        },
        {
            title: "Type de transaction",
            value: "transactionType",
            old: undefined,
            new: undefined,
            active: false,
            show: false,
        },
        {
            title: "Compte par défaut",
            value: "default",
            old: undefined,
            new: undefined,
            active: false,
            show: false,
        },
    ];

    isDefaulted = false;

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get rules() {
        return {
            aaLength: (v) => {
                return (
                    (!!v && v.length === this.aaCharacterCount) ||
                    "Nombre de caractères attendu= " + this.aaCharacterCount
                );
            },
            checkExists: (value) => {
                if (!this.existingAccountableAccounts) {
                    return true;
                }
                if (this.authorizeExistingAAModification) {
                    return true;
                }
                return (
                    (value && !this.existingAccountableAccounts.find((aa) => aa.name === value)) ||
                    "Compte existant"
                );
                // return checkIBAN(value) || this.$t('settings.wrongIBAN')
            },
            isAA: (value) => {
                return (value && checkInt(value)) || "Mauvais format";
                // return checkIBAN(value) || this.$t('settings.wrongIBAN')
            },
            thirdParty: (thirdParty) => {
                if (this.accountableAccountEdition.name?.startsWith("512")) {
                    if (thirdParty === "bankAccount") {
                        return true;
                    }
                    return "Selectionner Compte bancaire";
                }
                return true;
            },
        };
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get companyId() {
        return this.selectedCompany?.id;
    }

    get isAccountingClient() {
        if (this.$store.state.user.isAccountingClient) {
            return true;
        }
        return false;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany?.profile &&
            this.selectedCompany?.profile?.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get enableAccountPublish() {
        if (!!!this.$store.state.selected_company && !!this.$store.state.companyAccountingFirm.id) {
            //GI
            return true;
        }
        if (this.isIncomingOutgoingPayment && !this.isAccountingClient) {
            return true;
        }
        return false;
    }

    get isVatOrSalesAccount() {
        if (
            this.accountableAccountEdition.name.startsWith("70") ||
            this.accountableAccountEdition.name.startsWith("445")
        ) {
            return true;
        }
        return false;
    }

    get isVatAccount() {
        if (this.accountableAccountEdition.name.startsWith("445")) {
            return true;
        }
        return false;
    }

    get vatRates() {
        return vatRatesAccountableAccount;
    }

    get vatTypes() {
        if (this.accountableAccountEdition.name.startsWith("445")) {
            return vatTypesForVatAA;
        }
        return vatTypesForSalesAA;
    }

    get vatOperationTypes() {
        return [
            { value: null, text: "" },
            { value: "PURCHASE", text: "Achat" },
            { value: "PURCHASE_FIXED_ASSET", text: "Achat d'immobilisation" },
            { value: "SALE", text: "Vente" },
        ];
    }

    get isZtillReceipt() {
        if (
            this.accountableAccountEdition.name.startsWith("511") ||
            this.accountableAccountEdition.name.startsWith("58")
        ) {
            return true;
        }
        return false;
    }

    get isFiveAccount() {
        if (this.accountableAccountEdition.name.startsWith("5")) {
            return true;
        }
        return false;
    }

    get transactionTypes() {
        return [
            { value: null, text: "" },
            { value: "CASH", text: "Remise espèces" },
            { value: "CHEQUE", text: "Remise chèques" },
            { value: "CREDIT_CARD", text: "Remise cartes bleues" },
            { value: "TRANSFER", text: "Remise virement" },
            { value: "LUNCHEON_VOUCHER", text: "Remise tickets restaurant" },
            { value: "HOLIDAY_VOUCHER", text: "Remise chèque vacances" },
            { value: "PAYPAL", text: "Remise Paypal" },
            {
                value: "DISTRIBUTION_PLATFORM",
                text: "Remise Plateforme (Deliveroo, Uber eats .. )",
            },
            { value: "CREDIT_NOTES_ISSUED", text: "Remise - Avoirs émis" },
            { value: "CREDIT_NOTES_RECOVERY", text: "Remise - Reprise d'avoirs" },
            { value: "FREE", text: "Libre" },
        ];
    }
    
    is6Account(accountName) {
        return accountName.startsWith("6")
    }

    is6or7Account(accountName) {
        if (accountName.startsWith("6") || accountName.startsWith("7")) {
            return true;
        }
        return false;
    }

    beforeMount() {
        if (this.accountableAccount) {
            this.accountableAccountEdition = this.accountableAccount;
            if (this.fromParentTable) {
                this.propagation[0].old = this.accountableAccount.description;
                this.propagation[0].show = !this.accountableAccountEdition.disabled;
                this.propagation[1].old = this.accountableAccount.transactionType;
                this.propagation[1].show = this.isZtillReceipt;
                this.propagation[2].old = this.accountableAccount.default;
                this.propagation[2].show = this.isZtillReceipt;
            }
            this.isDefaulted = this.accountableAccount.default;

            // this.accountableAccountEdition.detailedCarryForward =
                // this.accountableAccountEdition.lettering;
        } else {
            this.accountableAccountEdition = new AANode(
                "",
                "",
                "",
                "",
                false,
                false,
                false,
                null,
                null,
                null,
                "",
                false,
                false,
                false,
                null,
                null,
                null,
                false,
            );
        }
    }

    @Watch("accountableAccountEdition.name")
    onAANameChanged() {
        if (this.accountableAccountEdition.name && this.authorizeExistingAAModification) {
            const foundAA = this.existingAccountableAccounts.find(
                (aa) => aa.name === this.accountableAccountEdition.name,
            );
            if (foundAA) {
                this.previousAccountableAccountEdition = _.cloneDeep(
                    this.accountableAccountEdition,
                );
                this.accountableAccountEdition.setData(foundAA);
            } else if (this.previousAccountableAccountEdition) {
                this.accountableAccountEdition.setData(this.previousAccountableAccountEdition);
                this.previousAccountableAccountEdition = null;
            }
        }
    }

    @Watch("letteringHasChangedCount")
    onLetteringChange() {
        this.accountableAccountEdition.detailedCarryForward =
            this.accountableAccountEdition.lettering;
    }

    @Watch("accountableAccountEdition.vatType")
    onVatTypeChange() {
        if (this.accountableAccountEdition.vatType) {
            this.accountableAccountEdition.vatRate = 0;
        }
    }

    @Watch("accountableAccountEdition.vatRate")
    onVatRateChange() {
        if (this.accountableAccountEdition.vatRate !== 0) {
            this.accountableAccountEdition.vatType = null;
        } else if (
            this.accountableAccountEdition.vatRate === 0 &&
            this.accountableAccountEdition.vatType === null
        ) {
            this.accountableAccountEdition.vatType = "NO_VAT_TYPE";
        }
    }

    preventDefaultDuplicates() {
        const transactionType = this.accountableAccountEdition.transactionType;
        if (transactionType) {
            const dupIndex = this.existingAccountableAccounts.findIndex(
                (aa) =>
                    aa.transactionType === transactionType &&
                    aa.name !== this.accountableAccountEdition.name,
            );
            if (dupIndex > -1) {
                this.propagation[1].old = this.existingAccountableAccounts[dupIndex].name;
                this.propagation[1].new = this.accountableAccountEdition.name;
                this.existingAccountableAccounts[dupIndex].default = false;
            }
        }
    }

    onValidateClick() {
        if (this.letteringHasChangedCount > 0 && !this.accountableAccountEdition.lettering) {
            this.confirmationDialog = true;
        } else {
            if (this.fromParentTable) {
                if (this.accountableAccountEdition.default) {
                    this.preventDefaultDuplicates();
                }
                this.propagation[0].new = this.accountableAccountEdition.description;
                this.propagation[1].new = this.accountableAccountEdition.transactionType;
                this.propagation[2].new = this.accountableAccountEdition.default;
                this.propagationDialog = true;
            } else {
                this.validate();
            }
        }
    }

    confirmPropagation() {
        this.propagationDialog = false;
        this.validate();
    }

    cancelPropagation() {
        this.propagationDialog = false;
    }

    confirmDeleteLetteringsChoice() {
        this.wantToDeleteLetterings = true;
        this.confirmationDialog = false;
        if (this.fromParentTable) {
            if (this.accountableAccountEdition.default) {
                this.preventDefaultDuplicates();
            }
            this.propagation[0].old = this.accountableAccount.description;
            this.propagation[1].old = this.accountableAccount.transactionType;
            this.propagation[2].old = this.accountableAccount.default;
            this.propagationDialog = true;
        } else {
            this.validate();
        }
    }

    cancelDeleteLetteringsChoice() {
        this.accountableAccountEdition.lettering = true;
        this.accountableAccountEdition.detailedCarryForward = true;
        this.confirmationDialog = false;
    }

    async validate() {
        this.accountableAccountEdition.type = getAccountableAccountType(
            this.accountableAccountEdition.name,
        );
        if (this.propagation.some((item) => item.active === true) && this.fromParentTable) {
            this.accountableAccountEdition.propagation = this.propagation;
            this.$emit("validate", this.accountableAccountEdition, true);
        } else {
            this.$emit("validate", this.accountableAccountEdition);
            if (this.wantToDeleteLetterings && !this.fromParentTable) {
                await this.deleteLetterings(this.accountableAccountEdition.id, this.companyId);
                this.wantToDeleteLetterings = false;
            }
        }
        this.dialog = false;
    }

    async deleteLetterings(accountableAccountId, companyId) {
        await this.$apollo.mutate({
            mutation: gql`
                mutation ($accountableAccountId: ID!, $companyId: ID!) {
                    deleteLetterings(
                        data: { accountableAccountId: $accountableAccountId, companyId: $companyId }
                    ) {
                        success
                    }
                }
            `,
            variables: {
                accountableAccountId: accountableAccountId,
                companyId: companyId,
            },
        });
        this.confirmationDialog = false;
    }

    get thirdPartyReadOnly() {
        if (this.accountableAccountEdition.name?.startsWith("512")) {
            if (this.accountableAccountEdition.thirdParty === "bankAccount") {
                return true;
            }
        }
        return false;
    }
}

export default toNative(AccountableAccountEdition);
</script>

<style lang="css">
.centered-input > .v-input__control {
    justify-content: center;
}
</style>
